module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-container"
  }, [_c('div', {
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "60px",
      "font-size": "14px",
      "font-family": "PingFangSC-Medium, PingFang SC",
      "font-weight": "500",
      "color": "#424242",
      "line-height": "20px"
    }
  }, [_vm._v("\n           开票抬头\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _vm._l((_vm.payEnterpriseList), function(payEnterprise, index) {
    return _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "border-bottom": ".5px solid #efeef3"
      }
    }, [_c('div', {
      class: _vm.getMainClass(payEnterprise)
    }, [_c('div', {
      staticClass: "open-popup open-enterprise",
      staticStyle: {
        "margin-top": "10px",
        "margin-left": "5px"
      },
      attrs: {
        "data-popup": ".popup-invoice-title"
      },
      on: {
        "click": function($event) {
          return _vm.openSerchPayEnterprise(index, false)
        }
      }
    }, [_vm._v("\n               " + _vm._s(_vm.getPayExperienceLabel(payEnterprise.enterpriseInvoiceTitle)) + "\n               "), (!payEnterprise.enterpriseInvoiceTitle) ? _c('span', [_vm._v("\n                点击搜索单位\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
      style: (_vm.getMainStyle(payEnterprise))
    }, [(_vm.canAddPayEnterprise) ? _c('span', {
      staticStyle: {
        "padding-right": "5px"
      }
    }, [_c('img', {
      staticClass: "icon6",
      staticStyle: {
        "width": "17px",
        "height": "12px"
      },
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/修 改.svg"
      },
      on: {
        "click": function($event) {
          return _vm.openSerchPayEnterprise(index, true)
        }
      }
    })]) : _vm._e()])])]), _vm._v(" "), _c('div', [(_vm.canAddPayEnterprise) ? _c('img', {
      staticClass: "icon5",
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/删减.svg"
      },
      on: {
        "click": function($event) {
          return _vm.removePayEnterprise(index)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAddPayEnterprise),
      expression: "canAddPayEnterprise"
    }],
    staticClass: "block-item",
    on: {
      "click": _vm.addPayEnterprise
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "del-btn",
    on: {
      "click": function($event) {
        return _vm.toPayInvoice()
      }
    }
  }, [_c('span', {
    staticClass: "tag",
    staticStyle: {
      "color": "#5878fa"
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-btn",
    on: {
      "click": function($event) {
        return _vm.submitPayEnterprise()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("确定修改")])])]), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("增加开票抬头")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "label7",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/增加备份.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e5c3c78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/MyInvoice/InvoiceTitleModify.vue
// module id = 1656
// module chunks = 8